import jQuery from 'jquery';
const $ = jQuery;

const initLoadVenues = () => {
  if (typeof $ === 'undefined') {
    console.log('jQuery is not loaded.');
    return false;
  }

  $('#load-more-venues').on('click', function(e){
    var last_letter = $(this).attr('data-last-letter');
    var next_letter = getNextLetter(last_letter);

    $.each(next_letter, function(index, value) {
      $('.current-letter[data-letter="' + value + '"]').show();
      $('.venue-box[data-letter="' + value + '"]').show();
      last_letter = value;
    });

    if (last_letter !== 'Z') {
      $(this).attr('data-last-letter', last_letter);
    } else {
      $(this).remove();
    }
  });

  function getNextLetter(next_letter) {
    var letters = [];

    var letter_1 = String.fromCharCode(next_letter.charCodeAt(0) + 1);
    var letter_2 = String.fromCharCode(letter_1.charCodeAt(0) + 1);
    var letter_3 = String.fromCharCode(letter_2.charCodeAt(0) + 1);

    letters.push(letter_1, letter_2, letter_3);

    return letters;
  }

};

export default initLoadVenues;